import React, { memo, FC } from 'react'

import { BodyText } from '@/containers/styles'
import { TimeLabelsProps } from '@/types/componentsPropsTypes'

import { formatDuration } from './formatDuration'
import { StyledTimeLabelContainer } from './styles'

const TimeLabelsRaw: FC<TimeLabelsProps> = ({
  currentTime,
  duration,
  currentTimeOnly = true,
}) => {
  return (
    <StyledTimeLabelContainer>
      <BodyText>
        {formatDuration(currentTime) +
          (!currentTimeOnly && ' / ' + formatDuration(duration))}
      </BodyText>
    </StyledTimeLabelContainer>
  )
}

export const TimeLabels = memo(TimeLabelsRaw)
